export default __webpack_public_path__ + "static/media/Wildstrider Girdle.0197557b.jpg";